import { render, staticRenderFns } from "./lottery-edit.vue?vue&type=template&id=0fea6950&scoped=true&"
import script from "./lottery-edit.vue?vue&type=script&lang=ts&"
export * from "./lottery-edit.vue?vue&type=script&lang=ts&"
import style0 from "./lottery-edit.vue?vue&type=style&index=0&id=0fea6950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea6950",
  null
  
)

export default component.exports